import loadable from '@loadable/component';

// 懒加载组件
const SysLookupManagement = loadable(() => import('./sysLookupManagement/SysLookupManagement'));
const SysProfileManagement = loadable(() => import('./sysProfileManagement/SysProfileManagement'));
const SysJobProcessingQuery = loadable(() => import('./sysJobProcessingQuery/SysJobProcessingQuery'));
const SysJobScheduleManagement = loadable(() => import('./sysJobScheduleManagement/SysJobScheduleManagement'));
const SysDataCheckManagement = loadable(() => import('./sysDataCheckManagement/SysDataCheckManagement'));
const SysApiManagement = loadable(() => import('./sysApiManagement/SysApiManagement'));
const AsyncReportManagement = loadable(() => import('./asyncReportManagement/AsyncReportManagement'));
const ExportManagement = loadable(() => import('./exportManagement/ExportManagement'));
const SysUserManagement = loadable(() => import('./sysUserManagement/SysUserManagement'));
const SysRoleManagement = loadable(() => import('./sysRoleManagement/SysRoleManagement'));
const SysMenuManagement = loadable(() => import('./sysMenuManagement/SysMenuManagement'));
const SysPrivilegeManagement = loadable(() => import('./sysPrivilegeManagement/SysPrivilegeManagement'));
const SysReportManagement = loadable(() => import('./sysReportManagement/SysReportManagement'));
const SysTodoManagement = loadable(() => import('./sysTodoManagement/SysTodoManagement'));
const SysDatasetManagement = loadable(() => import('./sysDatasetManagement/SysDatasetManagement'));
const SysNoticeManagement = loadable(() => import('./sysNoticeManagement/SysNoticeManagement'));
const MenuFieldSetting = loadable(() => import('./sysMenuFieldManagement/menuFieldSetting/MenuFieldSetting'));
const SysMenuFieldManagement = loadable(() => import('./sysMenuFieldManagement/SysMenuFieldManagement'));
const SysCodeRuleManagement = loadable(() => import('./sysCodeRuleManagement/SysCodeRuleManagement'));
const SysAgreementManagement = loadable(() => import('./sysAgreementManagement/SysAgreementManagement'));

export const subRoutes = [
  {
    // 101001系统：系统配置项字典
    path: '/SysLookupManagement',
    component: SysLookupManagement
  },
  {
    // 101002系统：系统参数设置
    path: '/SysProfileManagement',
    component: SysProfileManagement
  },
  {
    // 101003系统：执行中任务查询
    path: '/SysJobProcessingQuery',
    component: SysJobProcessingQuery
  },
  {
    // 101004系统：任务执行计划管理
    path: '/SysJobScheduleManagement',
    component: SysJobScheduleManagement
  },
  {
    // 101005系统：系统数据检查
    path: '/SysDataCheckManagement',
    component: SysDataCheckManagement
  },
  {
    // 101006系统：后端接口配置
    path: '/SysApiManagement',
    component: SysApiManagement
  },
  {
    // 101007系统：后台报表打印
    path: '/AsyncReportManagement',
    component: AsyncReportManagement
  },
  {
    // 101008系统：后台数据导出
    path: '/ExportManagement',
    component: ExportManagement
  },
  {
    // 102001系统：系统用户管理
    path: '/SysUserManagement',
    component: SysUserManagement
  },
  {
    // 102002系统：系统角色管理
    path: '/SysRoleManagement',
    component: SysRoleManagement
  },
  {
    // 102003系统：系统菜单管理
    path: '/SysMenuManagement',
    component: SysMenuManagement
  },
  {
    // 102003系统：系统菜单管理 --定制字段配置
    path: '/MenuFieldSetting',
    component: MenuFieldSetting
  },
  {
    // 102004系统：系统权限管理
    path: '/SysPrivilegeManagement',
    component: SysPrivilegeManagement
  },
  {
    // 102005系统：系统报表管理
    path: '/SysReportManagement',
    component: SysReportManagement
  },
  {
    // 102006系统：系统预警管理
    path: '/SysTodoManagement',
    component: SysTodoManagement
  },
  {
    // 102007系统：系统数据集管理
    path: '/SysDatasetManagement',
    component: SysDatasetManagement
  },
  {
    // 102008系统：系统公告管理
    path: '/SysNoticeManagement',
    component: SysNoticeManagement
  },
  {
    // 102009 页面字段管理
    path: '/SysMenuFieldManagement',
    component: SysMenuFieldManagement
  },
  {
    // 101009 单据代码前缀管理
    path: '/SysCodeRuleManagement',
    component: SysCodeRuleManagement
  },
  {
    // 102010系统：授权管理
    path: '/SysAgreementManagement',
    component: SysAgreementManagement
  }
];
